import { ChangeEvent, useMemo, useState } from "react";
import { t } from "i18next";
import { ExerciseType } from "@/components/v3/exercises/ExerciseBadge";
import { SpinnerLoader } from "@/components/ui/Loader";
import { useUserExercises } from "@/data/exercises.ts";
import { useNavigate, useParams } from "react-router-dom";
import AnswerSheet from "@/components/v3/exercises/AnswerSheet";
import ExerciseLayout from "@/layouts/ExerciseLayout.tsx";

function WritingExercise() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { exercises, isLoading } = useUserExercises();
  const exercise = useMemo(() => {
    const allExercises = [...exercises.toDo, ...exercises.done];
    return allExercises.find(ex => ex.token === id);
  }, [exercises, id]);

  const isPartTwo = useMemo(
    () =>
      !!exercise &&
      (exercise.name?.match(/Part|PART|2/g)?.length ?? 0) >= 2 &&
      exercise.count === 1,
    [exercise],
  );

  const [wordCount, setWordCount] = useState<number>(0);
  const changeHandler = (event: ChangeEvent<HTMLTextAreaElement>) => {
    const count = event.target.value
      .split(" ")
      .filter((word) => word.trim() !== "").length;
    setWordCount(count);
  };


  return (
    <ExerciseLayout
      type={ExerciseType.WRITING}
      title={exercise?.name}
      onClose={() => navigate(-1)}
      exercise={exercise}
    >
      {isLoading ? (
        <div className="flex items-center justify-center w-full h-full">
          <SpinnerLoader className="!h-12 !w-12 border-t-light" />
        </div>
      ) : (
        <AnswerSheet
          id={exercise?.id}
          exercise={exercise}
          renderSlots={() => (
            <div className="w-full h-full flex-[1_1_40%] min-h-0 lg:p-0">
              <form id="form-ex" className="flex flex-col h-full gap-y-3">
                <div className="flex flex-col until-xl:min-h-[50vh] bg-white rounded-[10px] p-2 h-full w-full">
                  <textarea
                    onChange={(event) => changeHandler(event)}
                    className="h-full flex-[1_1_100%] !ring-0 bg-white rounded-[10px] border-0"
                    placeholder={t("exercises.write_here")}
                  />

                  <p className="text-lg text-right text-black">
                    {wordCount}/{isPartTwo ? 150 : 250}
                  </p>
                </div>
              </form>
            </div>
          )}
        />
      )}
    </ExerciseLayout>
  );
}

export default WritingExercise;
